import React , {useState , useEffect} from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import { useNavigate } from "react-router-dom";
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
//
import Terminos from './Terminos';
//
import imagen from '../src/encabezado.jpg';
//

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
//
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
//
function RegistroComercio() {
        const [calle,setCalle] = useState('');
        const [numero,setNumero] = useState('');
        const [socio, setSocio] = useState(false);
        const [cuit,setCuit] = useState('');
        const [razonsocial,setRazonsocial] = useState('');
        const [email,setEmail] = useState('');
        const [contacto,setContacto] = useState('');
        const [web,setWeb] = useState('');
        const [whatsapp,setWhatsapp] = useState('');

        //const [selectedOption, setSelectedOption] = useState([]); 
        //const [selectedOptionRubros, setSelectedOptionRubros] = useState(null);
        const [msgok,setMsgok] = useState(false); 
        const [openError,setOpenError] = useState(false); 
        //const [msgno,setMsgno] = useState(false); 
        const [showAlert, setShowAlert] = useState(false);
        const [openTerminos, setOpenTerminos] = useState(false);
        const navigate = useNavigate() ;
        const [open, setOpen] = React.useState(false);

        const handleClickOpen = () => {
          setOpen(true);
        };
        const handleClose = () => {
          setOpen(false);
          volver();
        };
            
        // funciones
       
        const handleCloseAlert = (estado) => {
          setShowAlert(estado);
        };
        
        const handleError = () => {
          setOpenError(false);
        };
        const handleChange = (event) => {
            setSocio(event.target.value);
          };
    
        const handleSubmit = async (event) => {
          
            event.preventDefault();
            //
            const postData = {
                nombredefantasia : '',//nombredefantasia,
                cuit : cuit,
                razonsocial : razonsocial,
                calle : calle,
                numero : numero,
                email : email,
                contacto : contacto,
                socioucip : socio,
                aprobacion : false,
                fecha_alta : new Date(),
                fecha_aprobacion : new Date(),
                detalle_aprobacion : '',
                idrubro : -1,
                web : web,
                whatsapp : whatsapp
                };
                //
                try {
                    const baseURL = process.env.REACT_APP_SERVER_PATH + 'addComercio';
                    const res = await fetch(`${baseURL}`, {
                       
                      method: "post",
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": "token-value",
                        'Access-Control-Allow-Origin': '*'
                      },
                      body: JSON.stringify(postData),
                    });
                    console.log('status: '+res.status);
                    if (res.status === 200 ||res.status === 204) {
                      //setMsgok(true); //                      setNombredefantasia('');
                      setCuit('');
                      setRazonsocial('');
                      setCalle('');
                      setNumero('');
                      setEmail('');
                      setContacto('');
                      setSocio('');
                      setWeb('');
                      setWhatsapp('');
                      setOpen(true);
                      /*
                      setTimeout(() => {
                      volver(); 
                      }, 9000);
                      // ir al panel comercio y avisar que debe crear domicilios
                      */
                    } else
                    if (res.status === 505) 
                     {
                      setOpenError(true);
                     }

                        } catch (err) {
              console.log(err.message)
                  }
                //
          };
          const volver = () => {
            navigate('/')
            
          }  

          const verificaCUIT =(campo) => {
            let aux = 0;
            let arreglo = campo.split('');
            for (let index = 0; index < arreglo.length-1; index++) {
              // eslint-disable-next-line
              switch (index) {
                 case 0:
                     aux += parseInt(arreglo[index]) * 5;
                 break;
                 case 1: 
                     aux += parseInt(arreglo[index]) * 4; 
                 break;
                 case 2: 
                     aux += parseInt(arreglo[index]) * 3; 
                 break;
                 case 3: 
                     aux += parseInt(arreglo[index]) * 2; 
                 break;
                 case 4: 
                     aux += parseInt(arreglo[index]) * 7; 
                 break;
                 case 5: 
                     aux += parseInt(arreglo[index]) * 6; 
                   break;
                 case 6: 
                     aux += parseInt(arreglo[index]) * 5; 
                 break;
                 case 7: 
                     aux += parseInt(arreglo[index]) * 4; 
                 break;    
                 case 8: 
                     aux += parseInt(arreglo[index]) * 3; 
                 break;
                 case 9:
                     aux += parseInt(arreglo[index]) * 2; 
                    break;
             } 
            } //for
         aux = (aux % 11);
         // eslint-disable-next-line
         if ((11-aux != arreglo[10] && aux !=0) || (arreglo.length !== 11)) // && arreglo.length !== 0)
              {setShowAlert(true)}
         else 
              {setShowAlert(false)}
          } 
/*
          const getCentrosComerciales = () => {
            const baseURL = process.env.REACT_APP_SERVER_PATH+'getCentrosComerciales';
            fetch(`${baseURL}`)
            .then(res => res.json())
            .then(
              (result) => { setCentrosComerciales(result) 
              },
              (error) => {
              }
            )
           }
*/


           const handleCloseTerminos = () => {
            setOpenTerminos(false);
        
          };

          const setEmailextra = (valor) => {
            const nvo = valor.toLowerCase(); 
            setEmail(nvo);
          };

          useEffect( () => {
                   //getCentrosComerciales(); 
                   //getRubros();
     
        },[])
  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Gracias por registrarse
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
          Ya puede avanzar mediante sus credenciales para completar sus datos e imprimir el código QR.
          </Typography>

        </DialogContent>
        <DialogActions>
          <Button variant="contained" color ="primary" autoFocus onClick={handleClose} sx={{ mt: 2 ,mb: 2}}>
            Cerrar
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <Dialog
        open={openTerminos}
        onClose={handleCloseTerminos}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           <Terminos />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTerminos} autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openError}
        onClose={handleError}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Error en el registro"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           "Ya existe el CUIT"
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleError} autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

    <Container component="main" maxWidth="md">
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>

                <Grid item xs={8} >
                    <TextField
                    autoComplete="given-name"
                    name="calle"
                    required
                    fullWidth
                    id="calle"
                    label="Calle"
                    value = {calle}
                    onChange = {(e) => setCalle(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>
                <Grid item xs={4} >
                    <TextField
                    autoComplete="given-name"
                    name="numero"
                    required
                    fullWidth
                    id="numero"
                    label="Número"                  
                    type="number"
                    value = {numero}
                    onChange = {(e) => setNumero(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>
                <Grid item xs={3} >
                <TextField
                    name="cuit"
                    required //min="0" max="99999999999"
                    fullWidth
                    id="cuit"
                    label="CUIT"
                    type="number"
                    value = {cuit}
                    onChange = {(e) => setCuit(e.target.value)}
                    helpertext ="Campo requerido"
                    onBlur= {()=>verificaCUIT(cuit)}
                    />
                    {showAlert && (
                                 <Alert severity="warning" variant='filled' onClose={handleCloseAlert}>
                  <AlertTitle>CUIT incorrecto</AlertTitle>
                    verifíquelo</Alert> 
                    )}
                </Grid>

                <Grid item xs={9} >
                    <TextField
                    autoComplete="given-name"
                    name="razonsocial"
                    required
                    fullWidth
                    id="razonsocial"
                    label="Razón social"
                    value = {razonsocial}
                    onChange = {(e) => setRazonsocial(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>

                <Grid item xs={7}>
                    <TextField
                    required
                    fullWidth
                    id="email"
                    label="Correo Electrónico"
                    name="email"
                    autoComplete="email"
                    type = "email"
                    value = {email}
                    onChange = {(e) => setEmailextra(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>
                <Grid item xs={5}>
                    <TextField
                    required
                    fullWidth
                    id="contacto"
                    label="Nombre Contacto"
                    name="contacto"
                    autoComplete="Nombre Contacto"
                    type = "text"
                    value = {contacto}
                    onChange = {(e) => setContacto(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid> 
                <Grid item xs={12}>
                    <TextField
                    //required
                    fullWidth
                    id="web"
                    label="WEB"
                    name="contacto"
                    autoComplete="Nombre Contacto"
                    type = "text"
                    value = {web}
                    onChange = {(e) => setWeb(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid> 
                <Grid item xs={6}>
                    <TextField
                    //required
                    fullWidth
                    id="WhatsApp"
                    label="WhatsApp"
                    name="WhatsApp"
                    //autoComplete="Nombre Contacto"
                    type = "number"
                    value = {whatsapp}
                    onChange = {(e) => setWhatsapp(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>   
                              
                <Grid item xs={2}>
                <InputLabel  sx={{ mt: 2 }} id="simple-select-label">¿Es socio?</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <Select              
                    required
                    fullWidth
                        labelId="simple-select-label"
                        value={socio}
                        label="¿Es Socio?"
                        onChange={handleChange}
                    >
                        <MenuItem value = { true }>SI</MenuItem>
                        <MenuItem value = { false }>NO</MenuItem>                     
                    </Select>
                 
                </Grid>
            </Grid>
        </Box>
    </Container>
</div>
  )
}

export default RegistroComercio

/*
            <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            >
            Registrar
            </Button>
            <Button
            color="secondary"
            onClick={volver}
            fullWidth
            variant="contained"
            sx={{ mt: 2, mb: 2 }}
            >
            CANCELAR
            </Button>

*/
